export default "<div #content>\r\n    <ng-content></ng-content>\r\n</div>"